import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { colors } from '../../../../../../../colorVars';
import { closePartialPosition } from '../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/closePartialPosition';
import { closePctPosition } from '../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/closePctPosition';
import { flattenTradePlan } from '../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/flattenTradePlan';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import { ClosePctButton } from '../../../../../../atomic/buttons/closePctButton/ClosePctButton';
import TextButton from '../../../../../../atomic/buttons/textButton/TextButton';
import { TopRowBox } from '../topRowBox/TopRowBox';
import { TopRowBoxIncDecButtons } from '../topRowBox/TopRowBoxIncDecButtons';
import { TopRowInput } from '../topRowBox/TopRowInput';

export const CloseRow = observer(({ tradePlanId, type }) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId];
  const position =
    tradePlanStore.positions.tradeUnafraid[tradePlan?.positionId] ?? null;
  const totalTradePlanQty = position?.entryQuantity ?? null;
  const { positionSymbol, id } = tradePlan;
  const [qty, setQty] = useState(1);

  useEffect(() => {
    if (qty > totalTradePlanQty) setQty(totalTradePlanQty);
  }, [qty, totalTradePlanQty]);
  return (
    <>
      {type === 'pct' ? (
        <>
          <ClosePctButton
            margin="0 5px 0 0"
            percent={10}
            quantity={Math.ceil(totalTradePlanQty * 0.1)}
            clickHandler={() =>
              closePctPosition(id, 0.1, positionSymbol, null, true)
            }
          />
          <ClosePctButton
            margin="0 5px 0 0"
            percent={25}
            quantity={Math.ceil(totalTradePlanQty * 0.25)}
            clickHandler={() =>
              closePctPosition(id, 0.25, positionSymbol, null, true)
            }
          />
          <ClosePctButton
            margin="0 5px 0 0"
            percent={50}
            quantity={Math.ceil(totalTradePlanQty * 0.5)}
            clickHandler={() =>
              closePctPosition(id, 0.5, positionSymbol, null, true)
            }
          />
          <ClosePctButton
            margin="0 5px 0 0"
            percent={75}
            quantity={Math.ceil(totalTradePlanQty * 0.75)}
            clickHandler={() =>
              closePctPosition(id, 0.75, positionSymbol, null, true)
            }
          />
          <TextButton
            margin="0 5px 0 0"
            width="100px"
            color={colors.lightGrey}
            backgroundColor={colors.red}
            fontSize="medium"
            clickHandler={() => {
              flattenTradePlan(tradePlanId);
            }}
          >
            FLATTEN
          </TextButton>
        </>
      ) : (
        <>
          <TopRowBox
            backgroundColor={colors.grey}
            color={colors.lightGrey}
            width="100px"
          ></TopRowBox>
          <TopRowBoxIncDecButtons
            totalTradePlanQty={totalTradePlanQty}
            qty={qty}
            setQty={setQty}
            width="100px"
            backgroundColor={colors.grey}
            type="close"
          />
          <TopRowInput
            qty={qty}
            setQty={setQty}
            width="100px"
            backgroundColor={colors.grey}
          />
          <TextButton
            margin="0 5px 0 0"
            width="100px"
            color={colors.lightGrey}
            backgroundColor={colors.red}
            fontSize="medium"
            clickHandler={() =>
              closePartialPosition(tradePlanId, qty, positionSymbol, null, true)
            }
          >
            {`CLOSE ${qty}`}
          </TextButton>
          <TextButton
            margin="0 5px 0 0"
            width="100px"
            color={colors.lightGrey}
            backgroundColor={colors.red}
            fontSize="medium"
            clickHandler={() => flattenTradePlan(tradePlanId)}
          >
            FLATTEN
          </TextButton>
        </>
      )}
    </>
  );
});
